import { css } from 'styled-components'
// import { minMq } from '../../shared/styles/breakPoints'
import variables from '../../shared/styles/variables'


const eventAddr = css`
  font-weight: bold;
`
const eventDate = css`
  color: ${variables.BASE_TXC};
`
const listDisc = css`
  list-style: disc;
  padding-left:1.5em;
`
const strongCatch = css`
  font-size: 130%;
  font-weight: 700;
  margin-top:20px;
`
const yosan = css`
  color: ${variables.PINK};
  font-weight: 700;
`

export const no162Style = {
  eventAddr,
  eventDate,
  listDisc,
  strongCatch,
  yosan
}
